var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overlay',{class:{ hide: _vm.hideLogin, 'transition-out': _vm.transitionOutLogin },attrs:{"id":"login"}},[_c('LoginOverlayHeader'),_c('LoginOverlayContent',{on:{"login":_vm.login}}),_c('LoginOverlayFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }